import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import UserAvatar from "./UserAvatar";
import { flagUrl, teacherPath } from "../services/Helper";

// Desktop-only preview shown beside the teacher list; follows the hovered card.
export default function TeacherPreview({ data, top }) {
    const { t } = useTranslation();
    const location = useLocation();
    const prefix = location.pathname.startsWith("/app") ? "/app" : "";
    if (!data) return null;

    const firstName = (data?.name || '').trim().split(/\s+/)[0];
    const course = data?.featured_course;

    return (
        <aside className="tutor-preview" style={{ transform: `translateY(${top}px)` }}>
            <div className="tutor-preview-media">
                {course?.cover_video ?
                    <video key={data.id} src={course.cover_video} poster={data?.avatar} controls preload="metadata" playsInline />
                    :
                    <>
                        <UserAvatar key={data.id} src={data?.avatar} name={data?.name} size={400} />
                        <div className="tutor-preview-caption">
                            <span>{data?.name}</span>
                            {data?.country_code &&
                                <img src={flagUrl(data.country_code)} alt={data?.country_name || data.country_code}
                                     onError={(e) => { e.currentTarget.style.display = 'none'; }} />
                            }
                        </div>
                    </>
                }
            </div>

            {course?.title &&
                <p className="tutor-preview-course">
                    <i className="fa-light fa-circle-play" />{course.title}
                </p>
            }

            <div className="tutor-preview-actions">
                {course?.slug &&
                    <Link to={`${prefix}/course/${course.slug}`} className="btn tutor-btn-outline">{t("teacherPreview.view_course")}</Link>
                }
                <Link to={teacherPath(data, prefix)} className="btn tutor-btn-outline">
                    {t("teacherPreview.see_profile", { name: firstName })}
                </Link>
            </div>
        </aside>
    );
}
